<template>
  <div v-cloak id="cookie-block">
    <div class="notification"
         :class="{'active' : (isOpen && !arResult.IS_CONFIRM)}"
         v-show="isOpen && !arResult.IS_CONFIRM">
      <div class="wrapper">
        <div class="notification__item">
          <div class="notification__item-cont">
            <div class="notification__text">
              <p>Мы используем cookie файлы! Просматривая этот сайт, вы даете согласие на обработку файлов
                <a :href="arParams.LINK" target="_blank">cookie</a>
              </p>
            </div>
            <div class="notification__btn">
              <div class="n-close success" @click="confirm">Принять</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CookieComponent',
  props: {
    cookieData: null,
  },
  data() {
    return {
      isOpen: true,
      arResult: null,
      arParams: null,
      templatePath: null,
    };
  },
  computed: {},
  methods: {
    close() {
      this.isOpen = false;
    },
    confirm() {
      // eslint-disable-next-line
      BX.ajax.runComponentAction(
          'xpage:cookie',
          'confirm',
          {
            mode: 'class',
            data: {}
          }
      ).then(
          (response) => {
            if (response.status) {
              this.isOpen = false;
            }
          },
          (error) => {
            console.log(error);
          }
      );
    },
  },
  created() {
    if (this.cookieData) {
      this.arResult = this.cookieData.arResult
      this.arParams = this.cookieData.arParams
      this.templatePath = this.cookieData.templatePath
    } else {
      this.close()
    }
  },
  mounted() {
  },
  updated() {
  }
}
</script>